import { useEffect, useState } from "react";

export type PersistedStateType = "local" | "session";

export default function usePersistedState<T>(key: string, defaultValue: T, type: PersistedStateType = "session") {
  const storage = type === "local" ? window.localStorage : window.sessionStorage;

  const [state, setState] = useState<T>(() => {
    try {
      const persistedState: string | null = storage.getItem(key);

      const parsedState: T = persistedState ? JSON.parse(persistedState) : defaultValue;
      return parsedState;
    } catch (error) {
      return defaultValue;
    }
  });

  useEffect(() => {
    storage.setItem(key, JSON.stringify(state));
  }, [key, state]);

  return { state, setState };
}
